"use client";

import type * as React from "react";

// TODO: migrate to react aria alternative
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@ui/lib/utils";

interface RangeProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  ref?: React.Ref<React.ElementRef<typeof SliderPrimitive.Root>>;
}

const Range = ({ className, ref, ...props }: RangeProps) => (
  <SliderPrimitive.Root
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    ref={ref}
    {...props}
  >
    <SliderPrimitive.Track className='relative h-4 w-full grow overflow-hidden rounded-full bg-darker'>
      <SliderPrimitive.Range className='absolute h-full bg-inverse' />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className='effect-focus block h-16 w-16 rounded-full border-2 border-darkest bg-default' />
  </SliderPrimitive.Root>
);

Range.displayName = SliderPrimitive.Root.displayName;

export { Range };
